export enum QuestionTypeEnum {
    FreeText,
    MCOA,
    MCMA,
    YESNO,
    DATE,
    NOTE
}